define(['text!./templates/confirmation.html',
        'edge/quoteandbind/common/app'],
    (templateStr)=> {
        return [()=> {
            return {
                restrict: 'A',
                template: templateStr
            };
        }];
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/directives/Confirmation.js
 **/